import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { CoreLink } from '@uncinc/react-drupal-core';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';
import { IconCard } from '../../../../components';

const NavigationMobileMenuSubItem = ({
  subItem,
  handleLinkClick,
  closeAllModals,
}) => {
  const { t } = useTranslation();
  const subItemHref = subItem.getIn(['link', 'url']);
  const subItemTitle = subItem.getIn(['link', 'title'], '');
  const [isOpen, setOpen] = useState(false);

  const toggleOpen = () => {
    setOpen(!isOpen);
  };

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : 'unset';
  }, [isOpen]);

  useEffect(() => {
    setOpen(false);
  }, [closeAllModals]);

  return (
    <div key={`menu--main--sub-menu-item-${subItemTitle}:${subItemHref}`}>
      <div className="NavigationMainMenuMobile--subMenu__item">
        <CoreLink
          className="NavigationMainMenuMobile--subMenu__items__title"
          to={subItemHref}
        >
          <Container>
            <button type="button" className="NavigationMainMenu__subMenuPrefix" onClick={toggleOpen}>
              <h2>{subItemTitle}</h2>
              <div className="icon icon-chevron-right" />
            </button>
          </Container>
        </CoreLink>

        <div
          className={`NavigationMainMenuMobile--subMenu__links ${isOpen ? 'mobile--subitem-open' : ''}`}
        >
          <Container>
            <button type="button" className="NavigationMainMenuMobile--submenu__back" onClick={toggleOpen}>
              <div className="icon icon-chevron-right" />
              {t('menu.back')}
            </button>

            {subItem.getIn(['subtree']).map((link, index) => {
              const linkHref = link.getIn(['link', 'url']);
              const linkTitle = link.getIn(['link', 'title'], '');

              return (
                <div
                  key={`menu--main--sub-menu-item-${linkTitle}:${linkHref}`}
                  className="NavigationMainMenuMobile--subMenu__link"
                >
                  <IconCard
                    title={linkTitle}
                    href={linkHref}
                    onClick={() => {
                      handleLinkClick();
                      toggleOpen();
                    }}
                  />
                </div>
              );
            })}
          </Container>
        </div>
      </div>
    </div>
  );
};

export default NavigationMobileMenuSubItem;
